import h from 'hyperscript';

import { icon } from '@disy/ui/icon';

import './circle-progress-bar-button.css';

const COMPONENT_NAME = 'd-circle-progress-bar-button';

export class CircleProgressBarButton extends HTMLElement {
  readonly #button: HTMLButtonElement;
  /** icon displayed in center of button */
  readonly #icon: string;
  /** if true circle will be animated, static circle otherwise */
  readonly #animateProgressBar: boolean;
  /** if animationDuration isn't set, the default value in milliseconds that will be used */
  readonly #defaultAnimationDuration = 3000;
  /** duration in milliseconds in which circle progress animation will hit 100% */
  readonly #animationDuration?: number;

  constructor(buttonIcon: string, animationDuration?: number, animateProgressBar = false) {
    super();
    this.classList.add(COMPONENT_NAME);
    this.#icon = buttonIcon;
    this.#animateProgressBar = animateProgressBar;
    this.#animationDuration = animationDuration;
    this.#button = this.#createCircleBarButton();
  }

  connectedCallback() {
    this.append(this.#button);
  }

  #createCircleBarButton() {
    const circleProgressBar =
      this.#animateProgressBar ?
        [
          h(`.${COMPONENT_NAME}--mask.${COMPONENT_NAME}--full`, [h(`.${COMPONENT_NAME}--fill`)]),
          h(`.${COMPONENT_NAME}--mask`, [h(`.${COMPONENT_NAME}--fill`)]),
        ]
      : [];
    let circleWrapClassName = `${COMPONENT_NAME}--circle-wrap`;
    if (this.#animateProgressBar) {
      circleWrapClassName += `.${COMPONENT_NAME}--circle-wrap-active`;
    }
    return h<HTMLButtonElement>(
      `button.button.button-borderless.hidden-s.button-icon.${COMPONENT_NAME}--button`,
      {
        style: `--animation-duration:${this.#animationDuration ?? this.#defaultAnimationDuration}ms`,
      },
      [
        h(`.${circleWrapClassName}`, [...circleProgressBar]),
        h(`.${COMPONENT_NAME}--inside-circle`, [
          icon(this.#icon, { size: 's', styleClass: `${COMPONENT_NAME}--icon` }),
        ]),
      ],
    );
  }
}

customElements.define(COMPONENT_NAME, CircleProgressBarButton);
